import { render, staticRenderFns } from "./memo.vue?vue&type=template&id=6a258b9d&scoped=true&"
import script from "./memo.vue?vue&type=script&lang=js&"
export * from "./memo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a258b9d",
  null
  
)

export default component.exports